import { Autocomplete } from '@material-ui/lab';
import { Paper } from '@material-ui/core';
import React from 'react';

import FormTextFieldRedesign from 'retired/FormTextFieldRedesign';
import { useCountries } from 'entities/location/api';

const LocationSelectorRedesign = ({
  onSelect,
  passedCountries,
  initialLocation,
  required,
  meta,
  variant = 'outlined',
  label = 'Nonprofit location',
  placeholder = 'Select a country',
  helperText = placeholder,
  inputComponent: InputComponent = FormTextFieldRedesign,
  ...props
}): JSX.Element => {
  const defaultCountries = useCountries();
  const countries = passedCountries ?? defaultCountries;
  const defaultValue = countries.find((country) => country.countryCode === initialLocation);
  const isOutlined = variant === 'outlined';

  return (
    <Autocomplete
      disableClearable
      defaultValue={defaultValue}
      onChange={(event, newValue) => {
        onSelect(newValue?.countryCode ?? null);
      }}
      getOptionLabel={(option) => option.country}
      getOptionSelected={(option, value) => option.countryCode === value.countryCode}
      placeholder={placeholder}
      renderInput={(params) => (
        <InputComponent
          {...params}
          required={required}
          label={label}
          variant={variant}
          InputLabelProps={isOutlined ? { shrink: true } : null}
          meta={meta}
          helperText={helperText}
        />
      )}
      variant={variant}
      options={countries}
      PaperComponent={(paperProps) => <Paper {...paperProps} square={!isOutlined} />}
      {...props}
    />
  );
};

export default LocationSelectorRedesign;
